import axios from '@/utils/ajax';

/**
 * 经营等级相关接口
 */

// 获取经营等级信息
export const getBusinessLevelInfo = () => {
    return axios({
        url: '/bp/api/manage/info'
    });
};